
ADILF.define('streamhub-hot-collections/package-attribute',['require','exports','module','livefyre-package-attribute','json!streamhub-hot-collections/../package.json'],function (require, exports, module) {var packageAttributeBuilder = require('livefyre-package-attribute');
var packageJson = require('json!streamhub-hot-collections/../package.json');

module.exports = packageAttributeBuilder(packageJson);
});
